"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rightIcons = exports.leftIcons = void 0;
var icons_1 = require("@kawaui/icons");
exports.leftIcons = {
    date: icons_1.IconTravelDate,
    duration: icons_1.IconTravelLengthOfStay,
    search: icons_1.IconSearch,
    travelType: icons_1.IconTravelType
};
exports.rightIcons = {
    'arrow-down': icons_1.IconArrowDown,
    'arrow-right': icons_1.IconArrowRight,
    'arrow-up': icons_1.IconArrowUp,
    'cross': icons_1.IconCross
};
